import { render, staticRenderFns } from "./VLegalTextDetail.vue?vue&type=template&id=67065a5d&scoped=true"
import script from "./VLegalTextDetail.vue?vue&type=script&lang=js"
export * from "./VLegalTextDetail.vue?vue&type=script&lang=js"
import style0 from "./VLegalTextDetail.vue?vue&type=style&index=0&id=67065a5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67065a5d",
  null
  
)

export default component.exports